'use strict';

function blockArgumentsFunction(g) {
  function init() {
    calculWidth();
    $(window).on('resize', calculWidth);
  }

  function calculWidth() {
    var $blockArguments = $('.block-arguments');
    var $blockSingle = $blockArguments.find('.block-arguments__single');
    var totalWidth = 100 / $blockSingle.length;

    if (window.innerWidth >= 1024) {
      // Largeur du bloc total = 100%/nb d'arguments
      $blockSingle.css('width', totalWidth + '%');
    } else {
      $blockSingle.width('100%');
    }
  }

  init();
}
